// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://hzpqmmlpmiuhzoahiatf.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imh6cHFtbWxwbWl1aHpvYWhpYXRmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTM0NTQ2MjIsImV4cCI6MjA2OTAzMDYyMn0.al0CcFHKYl23cEdwNUgHBw8IRXAS13pYMRyWb93ioAQ";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});